// extracted by mini-css-extract-plugin
export default {"form":"FormInfo_form__Dnzqo","title":"FormInfo_title__ou8BG","input":"FormInfo_input__0Uf5h","btn":"FormInfo_btn__53kA4"};